import { rankList } from "@/mocks/gossip";

export default function RankSection() {
  return (
    <section id="rank" data-anchor className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-10">
          <div className="lg:col-span-3">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="mb-2 flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-accent-700">
                  <i className="ri-bar-chart-2-fill text-base" aria-hidden="true" />
                  热瓜榜单
                </p>
                <h2 className="text-2xl font-black text-foreground-950 md:text-4xl">此刻最热瓜</h2>
              </div>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs font-semibold text-foreground-600">
                <i className="ri-time-line text-sm text-accent-600" aria-hidden="true" />
                每 10 分钟实时刷新
              </span>
            </div>

            <ol className="mt-6 flex flex-col gap-3">
              {rankList.map((r) => (
                <li
                  key={r.id}
                  className="group flex items-center gap-3 rounded-2xl border border-background-200/70 bg-background-50 px-4 py-3.5 transition-colors hover:border-accent-300 md:gap-4 md:px-5"
                >
                  <span
                    className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl text-base font-black md:h-10 md:w-10 ${
                      r.id <= 3 ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-800"
                    }`}
                  >
                    {r.id}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-700 md:text-base">
                      {r.title}
                    </h3>
                    <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap rounded bg-accent-100 px-1.5 py-0.5 font-medium text-accent-800">
                        {r.category}
                      </span>
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-eye-line" aria-hidden="true" />
                        {r.online.toLocaleString()} 围观
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-bold text-foreground-950">
                      {r.heat.toFixed(1)}
                      <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
                    </span>
                    <span
                      className={`text-xs font-semibold ${
                        r.trend === "up"
                          ? "text-accent-600"
                          : r.trend === "down"
                            ? "text-foreground-400"
                            : "text-foreground-400"
                      }`}
                    >
                      {r.trend === "up" && (
                        <span className="inline-flex items-center gap-0.5">
                          <i className="ri-arrow-up-line" aria-hidden="true" />
                          上升
                        </span>
                      )}
                      {r.trend === "down" && (
                        <span className="inline-flex items-center gap-0.5">
                          <i className="ri-arrow-down-line" aria-hidden="true" />
                          回落
                        </span>
                      )}
                      {r.trend === "flat" && (
                        <span className="inline-flex items-center gap-0.5">
                          <i className="ri-drag-move-2-line" aria-hidden="true" />
                          持平
                        </span>
                      )}
                    </span>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:col-span-2">
            <div className="flex h-full flex-col overflow-hidden rounded-3xl bg-accent-900 text-background-100">
              <div className="flex items-center gap-3 px-6 pt-7">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent-700 text-xl text-background-50">
                  <i className="ri-live-line" aria-hidden="true" />
                </span>
                <div>
                  <p className="text-lg font-black text-background-50">吃瓜m 现场情报站</p>
                  <p className="text-xs text-background-100/80">话题走势 · 评论区见 · 瓜团讨论</p>
                </div>
              </div>
              <div className="flex-1 px-6 py-6">
                <ul className="flex flex-col gap-4">
                  {[
                    "不知道聊什么？点开今日热点话题，热门评论已帮你盘好前因后果。",
                    "想深度唠？进入对应瓜团，跟同好一起把细节聊透，不做表面围观。",
                    "观点不同？理性发言、互相尊重，把话说清楚，比吵赢更有意义。",
                  ].map((tip, idx) => (
                    <li key={idx} className="flex gap-3">
                      <span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-accent-600 text-xs font-black text-background-50">
                        {idx + 1}
                      </span>
                      <p className="text-sm leading-relaxed text-background-100/90">{tip}</p>
                    </li>
                  ))}
                </ul>
              </div>
              <a
                href="#feed"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#feed")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="mx-6 mb-6 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-background-50 px-4 py-3 text-sm font-bold text-accent-900 transition-colors hover:bg-background-100"
              >
                <i className="ri-arrow-right-s-line text-lg" aria-hidden="true" />
                去围观现场
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}